/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Untitled_NameInputs */



/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Team_Project_Import_Untitled_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_untitled_name = /** @type {((inputs?: Team_Project_Import_Untitled_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Untitled_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sans titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ohne Titel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Senza titolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Без названия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Intitulado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("無題")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्षकहीन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem título")
	return /** @type {LocalizedString} */ ("Untitled")
});